export default "__VITE_ASSET__CV26PAro__"